import React, { useEffect, useState } from 'react';
import Modal from "react-modal";
import ContactFormModal from "../../Contact/ContactFormModal.jsx";
import '../../Artists/ArtistsProfile.css';
import Oscarmimg from "../../../imgs/artists-imgs/chonae-pro.png";
import Oscarmbg from '../../../imgs/artists-imgs/chonae-banner.jpg';
import { FaInstagram, FaYoutube, FaTiktok } from 'react-icons/fa';

// Prevent screen readers from focusing on the background
Modal.setAppElement('#root');

function SocialBox({ href, className, children }) {
  if (href) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" className={className}>
        {children}
      </a>
    );
  }
  return <div className={className}>{children}</div>;
}

function SocialCounter({ targetNumber }) {
  const [currentNumber, setCurrentNumber] = useState(0);

  useEffect(() => {
    const duration = 1500; // Duration of the animation in ms
    const intervalTime = 50; // Interval at which the number increments
    const increment = Math.ceil(targetNumber / (duration / intervalTime)); // Calculate increment per interval

    const interval = setInterval(() => {
      setCurrentNumber((prevNumber) => {
        if (prevNumber + increment >= targetNumber) {
          clearInterval(interval);
          return targetNumber; // Ensure it stops at the final number
        }
        return prevNumber + increment;
      });
    }, intervalTime);

    return () => clearInterval(interval); // Cleanup on component unmount
  }, [targetNumber]);

  return <span>{currentNumber.toLocaleString()}</span>; // Format number with commas
}

function LaChonaPage() {
    // Modal Setup
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState("");
    const [currentArtist, setCurrentArtist] = useState("");
  
    const openModal = (title, artistName) => {
      setModalTitle(title); // Set button text as title
      setCurrentArtist(artistName); // Set the artist's name dynamically
      setIsModalOpen(true);
    };
    const closeModal = () => setIsModalOpen(false);


  const [isExpanded, setIsExpanded] = useState(false);

  const [followerCounts, setFollowerCounts] = useState({
    twitter: 8000,
    facebook: 158000,
    instagram: 54400,
    youtube: 7190,
    tiktok: 295000,
  });

  const [followerUrls, setFollowerUrls] = useState({
    facebook: "https://www.facebook.com/chonae210/",
    twitter: null,
    instagram: "https://www.instagram.com/chonae210/",
    youtube: "https://www.youtube.com/@chona.e",
    tiktok: "https://www.tiktok.com/@chonae210",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    fetch(process.env.PUBLIC_URL + "/followers.json")
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        const entry = data && data["chona-e"];
        if (!entry) return;
        const { urls, ...counts } = entry;
        setFollowerCounts((prev) => ({ ...prev, ...counts }));
        if (urls) setFollowerUrls((prev) => ({ ...prev, ...urls }));
      })
      .catch(() => {});
  }, []);

  const toggleBio = () => {
    setIsExpanded(!isExpanded);
  };

  const containerStyle = {
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.2)), url(${Oscarmbg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  };

  return (
    <div className="artists-bg" style={containerStyle}>
      <div className="artist-detail">
        <div className="artist-left">
          <img src={Oscarmimg} alt="Jerry Garcia" className="artistpro-image" />
        </div>
        <div className="artist-right">
          <h1 className="artist-name">Chona E</h1>

          {/* Social Media Follower Counter */}
          <div className="follower-section-compact">
            <SocialBox href={followerUrls.instagram} className="follower-box-compact instagram">
              <FaInstagram className="social-icon-compact" />
              <div className="follower-count-compact">
                <SocialCounter targetNumber={followerCounts.instagram} />
              </div>
              <div className="follower-text-compact">Followers</div>
            </SocialBox>

            <SocialBox href={followerUrls.youtube} className="follower-box-compact youtube">
              <FaYoutube className="social-icon-compact" />
              <div className="follower-count-compact">
                <SocialCounter targetNumber={followerCounts.youtube} />
              </div>
              <div className="follower-text-compact">Subscribers</div>
            </SocialBox>

            <SocialBox href={followerUrls.tiktok} className="follower-box-compact tiktok">
              <FaTiktok className="social-icon-compact" />
              <div className="follower-count-compact">
                <SocialCounter targetNumber={followerCounts.tiktok} />
              </div>
              <div className="follower-text-compact">Followers</div>
            </SocialBox>
          </div>

          {/* Buttons for Booking and Contact */}
        <div className="button-section">
        <button
          className="artist-button"
          onClick={() => openModal("Booking", "OSCAR M")}
        >
          Booking
        </button>
        <button
          className="artist-button"
          onClick={() => openModal("Contact", "OSCAR M")}
        >
          Contact
        </button>
      </div>

          {/* Modal Component */}
          <ContactFormModal
        isOpen={isModalOpen}
        onClose={closeModal}
        title={modalTitle} // Button text
        artistName={currentArtist} // Artist's name
        formAction="https://api.web3forms.com/submit" // Web3Forms API
      />

          <p className={`artists-bio ${isExpanded ? "expanded" : "collapsed"}`}>
          Chona E is not just your average comedian. She’s a force of nature who refused to let her dreams fade. After studying film and acting in the bustling cities of New York and Los Angeles at The American Music and Dramatic Academy, she found herself immersed in the whirlwind of marriage and motherhood. But the spark of performing never dimmed within her.
          In 2018, Chona E unleashed her infectious energy onto the world with a viral musical parody set to Cardi B’s “I Like It.” That electrifying moment propelled her into the comedy spotlight, and she hasn’t looked back since. Now, at the vibrant age of 40, Chona E has shared the stage with comedy giants and earned the title of Top Latina Comedian to watch by FuseTv.
          Her journey is a testament to the power of passion and perseverance. Through her performances, she embraces her Señora Era with gusto, proving that age is no barrier to chasing your dreams. Join Chona E as she lights up the stage, inspiring women everywhere to pursue their passions, no matter their age or life circumstances.
          </p>

          <button className="toggle-bio-button" onClick={toggleBio}>
            {isExpanded ? "Show Less" : "Read More"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default LaChonaPage;